import { render } from "./Registro02TC.vue?vue&type=template&id=736ea42e&scoped=true"
import script from "./Registro02TC.vue?vue&type=script&lang=js"
export * from "./Registro02TC.vue?vue&type=script&lang=js"

import "@/assets/css/registro02TC.css?vue&type=style&index=0&id=736ea42e&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736ea42e"]])

export default __exports__